<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button
          type="success"
          style="margin-left: 8vh"
          icon="el-icon-plus"
          @click="addPer"
          size="mini"
          >新增权限</el-button
        >
      </div>
    </div>

    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button
      type="primary"
      icon="el-icon-plus"
      plain
      @click="addPer"
      size="mini"
      style="margin-top: 2vh"
      >新增权限</el-button
    > -->
    <el-table
      :data="tableData"
      style="width: 100%; margin-bottom: 20px; margin-top: 2vh"
      row-key="id"
      border
      default-expand-all
      size="mini"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="display_name" label="名称" />
      <el-table-column prop="path" label="路径" />
      <el-table-column prop="method" label="请求方式" />
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <template>
            <el-button
              @click.native.prevent="update(scope.row)"
              type="primary"
              size="small"
              icon="el-icon-edit"
            >
              修改
            </el-button>
            <el-button
              @click.native.prevent="deleteRow(scope.row)"
              type="danger"
              size="small"
              icon="el-icon-delete"
            >
              删除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-row>
          <el-col :span="24" v-if="ifSub == 'add'">
            <el-form-item label="选择父菜单" prop="selectedItems">
              <el-cascader
                :options="cascaderOptions"
                v-model="form.selectedItems"
                :props="cascaderProps"
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="子菜单名称" prop="display_name">
              <el-input
                v-model="form.display_name"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="后端路径" prop="path">
              <el-input
                v-model="form.path"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请求方式" prop="method">
              <el-input
                v-model="form.method"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="前端路径" prop="method">
              <el-select
                v-model="form.url"
                placeholder="请选择"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in perMislist"
                  :key="item.menuid"
                  :label="item.menuname"
                  :value="item.menuid"
                />
              </el-select>
            </el-form-item>
            <!-- <el-cascader
                v-model="form.url"
                :options="routerData"
                :props="defaultProps"
              ></el-cascader>
            </el-form-item> -->
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否显示" prop="method">
              <el-radio-group v-model="form.is_display">
                <el-radio
                  v-for="item in regionTypes"
                  :label="item.label"
                  :key="item.label"
                  >{{ item.text }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getPermissionList,
  addPermission,
  editPermission,
  deletePer,
} from "../../api/permission";
import { mapState } from "vuex";

export default {
  data() {
    return {
      // 请求方式
      getTypeList: [
        {
          id: 1,
          title: "GET",
        },
        {
          id: 2,
          title: "POST",
        },
        {
          id: 3,
          title: "DELETE",
        },
        {
          id: 1,
          title: "PUT",
        },
      ],
      arrurl: "",
      defaultProps: {
        children: "menus",
        value: "menuid",
        label: "menuname",
        checkStrictly: true,
      },
      regionTypes: [
        {
          label: 1,
          text: "显示",
        },
        {
          label: 0,
          text: "隐藏",
        },
      ],
      tableData: [],
      // 弹窗显隐
      addOrEditOpen: false,
      // 校验
      rules: {
        display_name: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        path: [{ required: true, message: "请输入路径", trigger: "blur" }],
        method: [
          { required: true, message: "请输入请求方式", trigger: "blur" },
        ],
        selectedItems: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      // 标题
      title: "",
      // 判断是否添加修改
      ifSub: "",
      // 表单
      form: {},
      // 权限列表
      perMislist: [],
      // 处理数据
      updatedData: [],
      cascaderOptions: [],
      cascaderProps: {
        checkStrictly: true,
        value: "id",
        label: "display_name",
        children: "children",
      },
      selectedItems: [],
    };
  },
  computed: {
    ...mapState(["routerData"]),
  },
  methods: {
    // 处理数据
    convertToCascaderOptions(data, depth = 1, maxDepth = 3) {
      return data.map((item) => {
        const newItem = {
          id: item.id,
          display_name: item.display_name,
        };

        if (item.children && item.children.length > 0 && depth < maxDepth) {
          newItem.children = this.convertToCascaderOptions(
            item.children,
            depth + 1,
            maxDepth
          );
        }

        return newItem;
      });
    },
    // 添加权限
    addPer() {
      this.title = "添加";
      this.ifSub = "add";
      this.addOrEditOpen = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.updatedData = this.tableData.map((item) => {
        if (item.children && item.children.length > 0) {
          const updatedChildren = item.children.map((child) => {
            if (child.children && child.children.length > 0) {
              const nestedChildren = child.children.map((nestedChild) => {
                // 去掉最后一级的数据
                if (nestedChild.children && nestedChild.children.length > 0) {
                  return { ...nestedChild, children: [] };
                }
                return nestedChild;
              });
              return { ...child, children: nestedChildren };
            }
            return child;
          });
          return { ...item, children: updatedChildren };
        }
        return item;
      });
      this.cascaderOptions = this.convertToCascaderOptions(this.updatedData);
    },
    // 删除权限
    deleteRow(res) {
      this.$confirm("确定删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const req = await deletePer(res.id);
        if (req.code !== 200) return this.$message.error("删除失败!");
        this.addOrEditOpen = false;
        this.$message.success("删除成功");
        this.getPermissionLists();
        this.reset();
      });
    },
    // 修改权限
    update(req) {
      this.ifSub = "edit";
      this.addOrEditOpen = true;
      this.form = { ...req };
      if (this.form.url) {
        this.form.url = Number(this.form.url);
      }
      delete this.form.children;
    },
    // 弹窗关闭
    getout() {
      this.addOrEditOpen = false;
      this.reset();
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 重置
    reset() {
      this.form = {
        parent_id: undefined,
        display_name: undefined,
        path: undefined,
        method: undefined,
        selectedItems: undefined,
      };
      this.selectedItems = undefined;
    },
    // 提交表单
    submitForm() {
      this.$refs["form"].validate((vaild, err) => {
        if (vaild) {
          if (this.ifSub == "add") {
            this.form.parent_id = this.form.selectedItems.pop();
            delete this.form.selectedItems;
            addPermission(this.form).then((res) => {
              if (res.code !== 200) return this.$message.error("添加失败!");
              this.addOrEditOpen = false;
              this.$message.success("添加成功");
              this.getPermissionLists();
              this.reset();
            });
          } else {
            editPermission(this.form).then((res) => {
              if (res.code !== 200) return this.$message.error("修改失败!");
              this.addOrEditOpen = false;
              this.$message.success("修改成功");
              this.getPermissionLists();
              this.reset();
            });
          }
        }
      });
    },
    // 请求
    getPermissionLists() {
      getPermissionList()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch((err) => {
          this.$message.error("请求出错,请重试或联系管理员！");
        });
    },
    flattenMenuData(menuData, result = []) {
      for (let item of menuData) {
        result.push({ menuid: item.menuid, menuname: item.menuname });
        if (item.menus) {
          this.flattenMenuData(item.menus, result);
        }
      }
      return result;
    },
  },
  mounted() {
    this.getPermissionLists();
    let flatMenuData = this.flattenMenuData(this.routerData);

    let finalData = {
      menus: flatMenuData,
    };
    this.perMislist = finalData.menus;
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/permissions/index.vue